<template>
  <div class="agreement-page">
    <el-card class="filter-card" shadow="never">
      <div class="fg-row">
        <div class="fg-item">
          <span class="fg-label">录入时间</span>
          <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始" end-placeholder="结束"
            style="width: 230px" size="small" />
        </div>
        <div class="fg-item">
          <span class="fg-label">签字状态</span>
          <el-select v-model="signStatus" placeholder="全部" clearable size="small" style="width: 120px">
            <el-option v-for="t in statusTabs" :key="String(t.value)" :label="t.label" :value="t.value" />
          </el-select>
        </div>
        <div class="fg-item" v-if="isCompanyAdmin">
          <span class="fg-label">战队</span>
          <el-select v-model="unitId" placeholder="全部战队" clearable size="small" style="width: 130px" @change="onUnitChange" filterable>
            <el-option v-for="u in unitOptions" :key="u.id" :label="u.name" :value="u.id" />
          </el-select>
        </div>
        <div class="fg-item" v-if="isCompanyAdmin">
          <span class="fg-label">小组</span>
          <el-select v-model="teamId" placeholder="全部小组" clearable size="small" style="width: 140px" @change="onTeamChange" filterable>
            <el-option v-for="t in teamOptions" :key="t.id" :label="t.name" :value="t.id" />
          </el-select>
        </div>
        <div class="fg-item" v-if="isCompanyAdmin">
          <span class="fg-label">员工</span>
          <el-select v-model="staffId" placeholder="全部员工" clearable size="small" style="width: 140px" filterable>
            <el-option v-for="s in staffOptions" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </div>
        <div class="fg-item">
          <span class="fg-label">模板</span>
          <el-select v-model="templateId" placeholder="全部模板" clearable size="small" style="width: 150px" filterable>
            <el-option v-for="t in templateOptions" :key="t.id" :label="t.name" :value="t.id" />
          </el-select>
        </div>
        <div class="fg-item keyword">
          <el-input v-model="keyword" placeholder="乙方姓名 / 电话" clearable size="small" style="width: 170px" @keyup.enter.native="onSearch" @clear="onSearch" />
        </div>
        <div class="fg-btns">
          <el-button type="primary" size="small" icon="el-icon-search" @click="onSearch">查询</el-button>
          <el-button size="small" @click="onReset">重置</el-button>
        </div>
        <div class="fg-spacer"></div>
        <el-button type="primary" icon="el-icon-document-add" @click="openGenerate">生成协议</el-button>
      </div>
    </el-card>

    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无协议数据"
      >
        <el-table-column label="协议标题" min-width="180">
          <template slot-scope="{ row }">
            <span class="ag-title">{{ row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户" min-width="130">
          <template slot-scope="{ row }">
            <div class="cell-name-main">
              <div class="cell-name-text">{{ row.customer_name || '—' }}</div>
              <div class="cell-name-sub">{{ row.customer_phone || '' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="关联订单" min-width="150">
          <template slot-scope="{ row }">
            <span class="sn-text">{{ row.order_sn }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="staff_name" label="销售" min-width="90">
          <template slot-scope="{ row }">
            <span>{{ row.staff_name || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="签字状态" min-width="160" align="center">
          <template slot-scope="{ row }">
            <template v-if="parseInt(row.sign_status) === 2 && row.sign_time">
              <div class="cell-signed-time">{{ fmtDateTime(row.sign_time, true) }}</div>
            </template>
            <template v-else>
              <el-tag :type="statusTagType(row.sign_status)" size="small">{{ row.sign_status_text }}</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="签署地址" min-width="120" align="center">
          <template slot-scope="{ row }">
            <svg v-if="row.qr_url || row.sign_url" class="qr-icon" viewBox="0 0 1024 1024" style="width: 20px; height: 20px; cursor: pointer; color: #3668FC;" @click="openQr(row)">
              <path fill="currentColor" d="M48 48h160v160H48V48zm160 800H48V688h160v160zm176 0h80v80h-80v-80zm-176 0h96v-176h80v256H48V688h160v160zm160 0h96v-80h-96v80zm0-176h96v-80h-96v80zm160 272v-32h32v32h-32zm64-688h288v288H576V256zm128 128h32v-32h-32v32zM832 48h160v160H832V48zm-32 416v-32h80v-96h32v128h-80zm128-320h-32v-96h96v96h-64zm160 80v80h-80v-80h80zm0 176V512h-128v32h-96V448h96v-32h128zm-128 128h128v80h-80v80h48v-80h32v-144h-96v-128H576v128h-32v-64H448v160h-64v32h64v96h-32v80h48v-96h96v-96h64z" />
            </svg>
            <span v-else class="cell-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="{ row }">
            <span class="cell-time">{{ fmtDateTime(row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="340" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="goDetail(row)">查看</el-button>
            <el-button type="text" size="small" :loading="pdfExporting === row.id" @click="exportPdf(row)">导出PDF</el-button>
            <el-button v-if="row.pdf_url" type="text" size="small" @click="openPdf(row)">存档PDF</el-button>
            <el-button v-if="parseInt(row.sign_status) < 2" type="text" size="small" @click="doSign(row, 1)">发送</el-button>
            <el-button v-if="parseInt(row.sign_status) === 1" type="text" size="small" @click="doSign(row, 2)">签署</el-button>
            <el-dropdown v-if="row.sign_url" size="small" split-button type="text" @click="openSignLink(row)" @command="handleLinkCommand($event, row)">
              <i class="el-icon-link"></i> 链接
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="open">打开新标签</el-dropdown-item>
                <el-dropdown-item command="copy">复制链接</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button v-if="isCompanyAdmin" type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pager-row">
        <div class="pager-info-left" v-if="total > 0">
          <span class="info-tag">共 <span class="num">{{ total }}</span> 条记录</span>
        </div>
        <el-pagination
          background
          :layout="'total, prev, pager, next'"
          :pager-count="7"
          :total="total"
          :current-page.sync="page"
          :page-size="limit"
          @current-change="loadData"
        />
      </div>
    </el-card>

    <!-- 协议详情预览 -->
    <el-dialog :title="detail.title || '协议详情'" :visible.sync="detailVisible" width="720px" top="4vh">
      <div v-loading="detailLoading" class="detail-body">
        <div class="detail-head">
          <div class="detail-head-row">
            <span class="detail-sn">订单 {{ detail.order_sn || '—' }}</span>
            <el-tag :type="statusTagType(detail.sign_status)" size="small">{{ detail.sign_status_text }}</el-tag>
          </div>
          <div class="detail-head-cust">
            <span>{{ detail.customer_name || '—' }}</span>
            <span class="detail-phone">{{ detail.customer_phone || '' }}</span>
          </div>
        </div>
        <!-- 协议正文渲染（快照，转义换行） -->
        <div v-if="detail.content" class="agreement-content" v-html="renderContent(detail.content)"></div>
        <div v-else class="empty-row">暂无内容</div>
        <!-- 签署信息：甲方盖章(左) + 乙方签名(右) 并排同一行，与正文无缝衔接，签订日期下一行 -->
        <div v-if="detail.seal || detail.customer_name || detail.signature || detail.sign_time" class="detail-sign-block">
          <div class="sign-row">
            <div class="sign-cell">
              <div class="sign-line"><span class="sign-label">甲方盖章</span></div>
              <div class="sign-box">
                <img v-if="detail.seal" :src="resolveAsset(detail.seal)" class="seal-img" alt="甲方盖章" />
                <span v-else class="sign-empty">—</span>
              </div>
            </div>
            <div class="sign-cell">
              <div class="sign-line"><span class="sign-label">乙方签名</span></div>
              <div class="sign-box">
                <img v-if="detail.signature && parseInt(detail.sign_status) === 2" :src="resolveAsset(detail.signature)" class="sig-img" alt="乙方签名" />
                <span v-else class="sign-empty">（未签）</span>
              </div>
            </div>
          </div>
          <div class="sign-line date"><span class="sign-label">签订日期</span><span class="sign-value">{{ pdfSignDate(detail) }}</span></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="parseInt(detail.sign_status) < 2" type="primary" size="small" @click="doSignDetail(1)">标记已发送</el-button>
        <el-button v-if="parseInt(detail.sign_status) === 1" type="primary" size="small" @click="doSignDetail(2)">标记已签署</el-button>
        <el-button size="small" @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 生成协议弹窗 -->
    <el-dialog title="生成协议" :visible.sync="genVisible" width="640px" :close-on-click-modal="false">
      <div class="gen-mode">
        <el-radio-group v-model="genForm.manner" size="small">
          <el-radio-button label="order">选择订单</el-radio-button>
          <el-radio-button label="manual">手动输入</el-radio-button>
        </el-radio-group>
      </div>
      <el-form ref="genForm" :model="genForm" :rules="genRules" label-width="100px" size="small">
        <template v-if="genForm.manner === 'order'">
          <el-form-item label="选择订单" prop="order_id">
            <el-select v-model="genForm.order_id" placeholder="请选择订单" style="width: 100%" filterable>
              <el-option v-for="o in orderOptions" :key="o.id" :label="o.customer_name + ' · ' + o.order_sn" :value="o.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="选择模板">
            <el-select v-model="genForm.template_id" placeholder="该商品未绑定模板，请选择" style="width: 100%" filterable>
              <el-option v-for="t in templateOptions" :key="t.id" :label="t.name" :value="t.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="退款金额" prop="refund_amount">
            <el-input v-model="genForm.refund_amount" :maxlength="20" placeholder="选填" />
          </el-form-item>
        </template>
        <template v-else>
          <div class="gen-manual-grid">
            <el-form-item label="选择模板" prop="template_id">
              <el-select v-model="genForm.template_id" placeholder="请选择模板" style="width: 100%" filterable>
                <el-option v-for="t in templateOptions" :key="t.id" :label="t.name" :value="t.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="乙方姓名" prop="name">
              <el-input v-model="genForm.name" :maxlength="50" placeholder="选填" />
            </el-form-item>
            <el-form-item label="乙方电话" prop="phone">
              <el-input v-model="genForm.phone" :maxlength="20" placeholder="选填" />
            </el-form-item>
            <el-form-item label="身份证号" prop="id_card">
              <el-input v-model="genForm.id_card" :maxlength="30" placeholder="选填" />
            </el-form-item>
            <el-form-item label="商品名" prop="product_name">
              <el-input v-model="genForm.product_name" :maxlength="100" placeholder="选填" />
            </el-form-item>
            <el-form-item label="商品原价" prop="original_price">
              <el-input v-model="genForm.original_price" :maxlength="20" placeholder="选填" />
            </el-form-item>
            <el-form-item label="商品价格" prop="price">
              <el-input v-model="genForm.price" :maxlength="20" placeholder="选填" />
            </el-form-item>
            <el-form-item label="退款金额" prop="refund_amount">
              <el-input v-model="genForm.refund_amount" :maxlength="20" placeholder="选填" />
            </el-form-item>
            <el-form-item label="当天日期" prop="today">
              <el-date-picker v-model="genForm.today" type="date" value-format="yyyy-MM-dd" style="width: 100%" placeholder="选填" />
            </el-form-item>
          </div>
        </template>
        <!-- 模板变量：选中模板时按该模板的 params 动态渲染输入框；
             未选模板时兜底渲染「邮箱 / qq」两个（fa_order 无 email/qq 列，
             订单方式永远取不到，必须能手工补）。留空不提交，避免覆盖订单带出的真实值。 -->
        <template v-if="dynamicVars.length || fallbackVars.length">
          <div class="dyn-vars-head">
            <span class="dyn-vars-title">模板变量</span>
            <span class="dyn-vars-tip" :class="{ 'is-warn': needTemplateHint }">
              {{ needTemplateHint
                ? '该订单的商品未绑定协议模板，请先在上方「选择模板」'
                : (dynamicVars.length ? '取自当前模板，留空不参与替换' : '模板外的常用变量；选定模板可填其全部变量') }}
            </span>
          </div>
          <div class="gen-manual-grid">
            <el-form-item v-for="v in (dynamicVars.length ? dynamicVars : fallbackVars)" :key="v" :label="v">
              <el-input v-model="genForm.extraParams[v]" :maxlength="200" placeholder="选填" />
            </el-form-item>
          </div>
        </template>
        <el-form-item label="退款渠道">
          <el-input v-model="genForm.refund_channel" :maxlength="50" placeholder="选填（模板变量「退款渠道」）" />
        </el-form-item>
        <el-form-item label="报名时间">
          <el-input v-model="genForm.signup_time" :maxlength="30" placeholder="选填（模板变量「报名时间」）" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="genForm.template_remark" type="textarea" :rows="2" :maxlength="500" placeholder="选填（模板变量「备注」）" />
        </el-form-item>
        <el-form-item label="合同标题">
          <el-input v-model="genForm.title" :maxlength="100" placeholder="留空则用模板名" />
        </el-form-item>
        <el-form-item label="生成备注">
          <el-input v-model="genForm.remark" type="textarea" :maxlength="500" :rows="2" placeholder="选填，生成备注不进入协议正文" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="genVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="genLoading" @click="doGenerate">生 成</el-button>
      </div>
    </el-dialog>

    <!-- 扫码签署弹窗 -->
    <el-dialog title="扫码签署" :visible.sync="qrVisible" width="400px" top="12vh">
      <div class="qr-dialog-body">
        <div v-if="qrData.qr_url" class="qr-img-wrap">
          <img :src="resolveAsset(qrData.qr_url)" class="qr-img" alt="签署二维码" />
        </div>
        <div v-else class="qr-empty">该协议暂无签署地址</div>
        <div v-if="qrData.title" class="qr-title">{{ qrData.title }}</div>
        <div class="qr-tip">客户扫描二维码后在签署页查看并完成签署</div>
        <div v-if="qrData.sign_url" class="qr-link">
          <a class="qr-link-text" :href="qrData.sign_url" target="_blank" rel="noopener noreferrer">{{ qrData.sign_url }}</a>
          <el-button type="text" size="small" @click.stop="copySign(qrData.sign_url)">复制</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agreementList, agreementDetail, agreementSign, agreementGenerate, agreementDelete, templateList } from '@/api/agreement'
import { unitList, teamList, staffList } from '@/api/org'
import { orderList } from '@/api/order'
import { productList } from '@/api/base'
import { API_BASE } from '@/config'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

// 后端资源根（用当前页面 origin 拼接绝对地址，确保离屏截图 / 导出 PDF 时相对路径资源可被加载）
const ASSET_BASE = (typeof window !== 'undefined' && window.location) ? window.location.origin : ''

const STATUS_TABS = [
  { label: '全部', value: '' },
  { label: '未签字', value: -1 },
  { label: '已签字', value: 2 }
]

// 系统自动计算 / 由系统或模板给定，任何方式下都不给输入框
const SYSTEM_VARS = ['金额大写', '商品价格大写', '录入时间', '机构名', '主体名称']
// 生成弹窗里已有独立输入框（两种方式共用）
const SHARED_INPUTS = ['退款渠道', '报名时间', '备注']
// 手动方式下已有独立输入框
const MANUAL_INPUTS = ['乙方姓名', '乙方电话', '身份证号', '商品名', '商品原价', '商品价格', '退款金额', '当天日期']
// 订单方式下「订单/商品必然带出」的字段（对应 NOT NULL 列）
// 注意：只排除必然有值的；可能为空的（身份证号/量账号/所在地区/订单备注/商品原价/商品内容/商品备注）
// 一律保留输入框，否则模板里用到了却无处可填。
const ORDER_AUTO = ['乙方姓名', '乙方电话', '订单号', '商品名', '商品价格', '成交日期', '当天日期']
// 订单方式下弹窗里已有的独立输入框
const ORDER_INPUTS = ['退款金额']

// 各方式下「不需要再渲染输入框」的变量集合
const COVERED = {
  order: SYSTEM_VARS.concat(SHARED_INPUTS, ORDER_INPUTS, ORDER_AUTO),
  manual: SYSTEM_VARS.concat(SHARED_INPUTS, MANUAL_INPUTS)
}

export default {
  name: 'AgreementList',
  data() {
    return {
      list: [],
      statusTabs: STATUS_TABS,
      signStatus: '',
      page: 1,
      limit: 20,
      total: 0,
      loading: false,
      // 筛选
      dateRange: [],
      keyword: '',
      unitOptions: [],
      teamOptions: [],
      staffOptions: [],
      unitId: null,
      teamId: null,
      staffId: null,
      templateId: null,
      // 详情
      detailVisible: false,
      detailLoading: false,
      detail: {},
      // 生成
      genVisible: false,
      genLoading: false,
      genForm: {
        manner: 'order',
        order_id: null,
        template_id: null,
        title: '',
        name: '',
        phone: '',
        id_card: '',
        product_name: '',
        original_price: '',
        price: '',
        refund_amount: '',
        today: '',
        remark: '',
        refund_channel: '',
        signup_time: '',
        template_remark: '',
        // 模板变量值（键=变量名，生成时以 extra_params 提交，空值不提交）
        extraParams: {}
      },
      genRules: {
        // 仅「选择订单」的订单为必要前提；其余信息全部选填
        order_id: [{ required: true, message: '请选择订单', trigger: 'change' }]
      },
      orderOptions: [],
      // 商品 → 绑定模板 映射（订单方式未手选模板时，后端按商品绑定模板生成，前端据此才能列全变量）
      productTemplateMap: {},
      templateOptions: [],
      // 扫码签署
      qrVisible: false,
      qrData: {},
      qrBaseUrl: '',
      // 导出 PDF
      pdfExporting: null
    }
  },
  computed: {
    // 仅机构管理员可删除协议
    isCompanyAdmin() {
      const u = this.$store && this.$store.state && this.$store.state.user
      return !!u && u.type === 'company'
    },
    // 实际用于渲染的模板：显式选择优先；订单方式未选时按「商品绑定模板」推断
    //（后端 generate() 也是这么取的：template_id=0 → 取该订单商品的 template_id）
    effectiveTemplateId() {
      if (this.genForm.template_id) return this.genForm.template_id
      if (this.genForm.manner === 'order' && this.genForm.order_id) {
        const o = (this.orderOptions || []).find(x => String(x.id) === String(this.genForm.order_id))
        const pid = o && o.product_id ? o.product_id : 0
        if (pid && this.productTemplateMap[pid]) return this.productTemplateMap[pid]
      }
      return null
    },
    // 当前模板声明的变量（排除已有输入框 / 系统自动计算），用于动态渲染输入框
    dynamicVars() {
      const id = this.effectiveTemplateId
      if (!id) return []
      const tpl = (this.templateOptions || []).find(t => String(t.id) === String(id))
      if (!tpl || !tpl.params) return []
      const skip = this.genForm.manner === 'order' ? COVERED.order : COVERED.manual
      const out = []
      String(tpl.params).split(',').forEach(s => {
        const name = s.trim().replace(/^\$+/, '')
        if (!name || skip.indexOf(name) !== -1 || out.indexOf(name) !== -1) return
        out.push(name)
      })
      return out
    },
    // 推不出模板时的兜底：fa_order 无 email/qq 列，订单方式也带不出来，必须可手工补
    fallbackVars() {
      return this.effectiveTemplateId ? [] : ['邮箱', 'qq']
    },
    // 订单方式下选了订单却推不出模板（商品未绑定协议模板）→ 明确提示去选模板
    needTemplateHint() {
      return this.genForm.manner === 'order' && !!this.genForm.order_id && !this.effectiveTemplateId
    }
  },
  watch: {
    // Vue2 新增对象键需 $set 才响应；变量集变化时补齐 extraParams 的键
    dynamicVars(list) {
      const obj = this.genForm.extraParams
      ;(list || []).forEach(k => { if (!(k in obj)) this.$set(obj, k, '') })
    },
    // 订单方式：切换订单时把该商品绑定的协议模板回填到「选择模板」（换单=换商品，直接覆盖）
    'genForm.order_id'(id) {
      this.syncProductTemplate(id, true)
    },
    // 切回订单方式时也回填一次（缺省不覆盖已有选择）
    'genForm.manner'(m) {
      if (m === 'order') this.syncProductTemplate(this.genForm.order_id, false)
    }
  },
  created() {
    this.loadFilters()
    this.reload()
  },
  methods: {
    /* 加载筛选下拉：战队（仅机构管理员）/ 模板 */
    loadFilters() {
      if (this.isCompanyAdmin) {
        unitList()
          .then(data => { this.unitOptions = (data && data.list) || [] })
          .catch(() => { this.unitOptions = [] })
      }
      templateList()
        .then(data => { this.templateOptions = (data && data.list) || [] })
        .catch(() => { this.templateOptions = [] })
    },
    /* 选择战队 → 加载该战队小组，清空小组/员工 */
    onUnitChange() {
      this.teamId = null
      this.staffId = null
      this.teamOptions = []
      this.staffOptions = []
      if (this.unitId) {
        teamList({ unit_id: this.unitId })
          .then(data => { this.teamOptions = (data && data.list) || [] })
          .catch(() => { this.teamOptions = [] })
      }
    },
    /* 选择小组 → 加载该小组员工，清空员工 */
    onTeamChange() {
      this.staffId = null
      this.staffOptions = []
      if (this.teamId) {
        const p = { team_id: this.teamId }
        if (this.unitId) p.unit_id = this.unitId
        staffList(p)
          .then(data => { this.staffOptions = (data && data.list) || [] })
          .catch(() => { this.staffOptions = [] })
      }
    },
    /* 查询/重置 */
    onSearch() {
      this.reload()
    },
    onReset() {
      this.dateRange = []
      this.signStatus = ''
      this.keyword = ''
      this.unitId = null
      this.teamId = null
      this.staffId = null
      this.templateId = null
      this.teamOptions = []
      this.staffOptions = []
      this.reload()
    },
    reload() {
      this.page = 1
      this.loadData()
    },
    // 后端相对路径资源 → 完整可访问地址
    resolveAsset(url) {
      if (!url) return ''
      if (/^https?:\/\//.test(url)) return url
      if (/^\//.test(url)) return ASSET_BASE + url
      return url
    },
    loadData() {
      this.loading = true
      const params = { page: this.page, limit: this.limit }
      if (this.signStatus !== '') params.sign_status = this.signStatus
      if (this.keyword) params.keyword = this.keyword
      if (this.unitId) params.unit_id = this.unitId
      if (this.teamId) params.team_id = this.teamId
      if (this.staffId) params.staff_id = this.staffId
      if (this.templateId) params.template_id = this.templateId
      if (Array.isArray(this.dateRange) && this.dateRange.length === 2) {
        params.start_date = this.dateRange[0]
        params.end_date = this.dateRange[1]
      }
      agreementList(params)
        .then(data => {
          this.list = data.list || []
          this.total = data.total || 0
        })
        .catch(() => { this.list = []; this.total = 0 })
        .finally(() => { this.loading = false })
    },
    goDetail(row) {
      this.detail = {}
      this.detailVisible = true
      this.detailLoading = true
      agreementDetail(row.id)
        .then(data => { this.detail = data || {} })
        .catch(() => {})
        .finally(() => { this.detailLoading = false })
    },
    doSign(row, status) {
      const confirmMsg = status === 1 ? `确认将「${row.title}」标记为已发送？` : `确认标记为已签署？签署后不可更改。`
      this.$confirm(confirmMsg, status === 2 ? '签署协议' : '发送协议', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        agreementSign(row.id, status)
          .then(() => {
            this.$message.success(status === 2 ? '已签署' : '已发送')
            this.loadData()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    doSignDetail(status) {
      agreementSign(this.detail.id, status)
        .then(() => {
          this.$message.success(status === 2 ? '已签署' : '已发送')
          this.goDetail({ id: this.detail.id })
          this.loadData()
        })
        .catch(() => {})
    },
    /* 删除协议（仅机构管理员） */
    doDelete(row) {
      this.$confirm(`确认删除协议「${row.title}」？删除后不可恢复。`, '删除协议', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        agreementDelete(row.id)
          .then(() => {
            this.$message.success('已删除')
            this.loadData()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    /* 打开签署二维码弹窗 */
    openQr(row) {
      this.qrData = {
        title: row.title,
        sign_url: row.sign_url,
        qr_url: row.qr_url
      }
      this.qrVisible = true
    },
    /* 签署链接：新标签打开 */
    openSignLink(row) {
      if (!row.sign_url) {
        this.$message.warning('该协议尚未生成签署链接')
        return
      }
      window.open(row.sign_url, '_blank')
    },
    /* 签署链接下拉命令：打开 / 复制 */
    handleLinkCommand(command, row) {
      if (command === 'open') {
        this.openSignLink(row)
      } else if (command === 'copy') {
        this.copySign(row.sign_url)
      }
    },
    /* 打开已签署协议 PDF */
    openPdf(row) {
      if (!row.pdf_url) {
        this.$message.warning('该协议尚未生成 PDF')
        return
      }
      const url = this.resolveAsset(row.pdf_url)
      window.open(url, '_blank')
    },
    /* 导出协议为 PDF（前端 html2canvas + jsPDF 生成） */
    async exportPdf(row) {
      // 每次重新拉最新详情，确保含最新签名图
      let detail
      try {
        detail = await agreementDetail(row.id)
      } catch (e) {
        this.$message.error('加载协议失败')
        return
      }
      if (!detail || !detail.id) {
        this.$message.error('加载协议失败')
        return
      }
      this.pdfExporting = row.id
      // 离屏容器（A4 宽度约 794px @96dpi），供 html2canvas 捕获
      const holder = document.createElement('div')
      holder.style.cssText = 'position:fixed;left:-9999px;top:0;width:794px;background:#fff;z-index:-1;'
      holder.innerHTML = this.buildPdfHtml(detail || {})
      document.body.appendChild(holder)
      // 等图片（含签名）加载完再截图
      const imgs = Array.from(holder.querySelectorAll('img'))
      await Promise.all(imgs.map(img => new Promise(res => {
        if (img.complete) return res()
        img.onload = res
        img.onerror = res
      })))
      try {
        const canvas = await html2canvas(holder, { scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false })
        const pdf = new jsPDF('p', 'mm', 'a4')
        const pw = pdf.internal.pageSize.getWidth()
        const ph = pdf.internal.pageSize.getHeight()
        const imgH = (canvas.height * pw) / canvas.width
        let left = imgH
        let y = 0
        const dataUrl = canvas.toDataURL('image/jpeg', 0.95)
        pdf.addImage(dataUrl, 'JPEG', 0, y, pw, imgH)
        left -= ph
        while (left > 0) {
          y -= ph
          pdf.addPage()
          pdf.addImage(dataUrl, 'JPEG', 0, y, pw, imgH)
          left -= ph
        }
        const name = detail && detail.title ? detail.title : '协议'
        const cust = detail && detail.customer_name ? detail.customer_name : ''
        pdf.save(cust ? `${name}_${cust}.pdf` : `${name}.pdf`)
        this.$message.success('已导出 PDF')
      } catch (e) {
        this.$message.error('导出失败，请重试')
      } finally {
        document.body.removeChild(holder)
        this.pdfExporting = null
      }
    },
    /* 组装 PDF HTML 内容 */
    buildPdfHtml(d) {
      const esc = v => this.escapeHtml(v)
      const title = d.title ? esc(d.title) : '协议'
      const sub = []
      if (d.order_sn) sub.push('订单号 ' + esc(d.order_sn))
      if (d.customer_name) sub.push(esc(d.customer_name))
      if (d.customer_phone) sub.push(esc(d.customer_phone))
      // 甲方盖章(左) 与 乙方签名(右) 并排同一行（inline-block 并排）
      const sealBox = d && d.seal
        ? `<div style="display:inline-block;vertical-align:top;margin-right:40px;"><div style="font-size:15px;color:#18233C;margin-bottom:8px;">甲方盖章</div>` +
          `<img src="${this.resolveAsset(d.seal)}" style="max-width:200px;max-height:140px;border:1px dashed #E2E6EE;padding:8px;border-radius:8px;"/></div>` : ''
      const signBox = d.signature && parseInt(d.sign_status) === 2
        ? `<div style="display:inline-block;vertical-align:top;"><div style="font-size:15px;color:#18233C;margin-bottom:8px;">乙方签名</div>` +
          `<img src="${this.resolveAsset(d.signature)}" style="max-width:280px;max-height:140px;border:1px dashed #E2E6EE;padding:8px;border-radius:8px;"/></div>` : ''
      const sealWrap = (signBox || sealBox) ? `<div style="margin-top:24px;">${sealBox}${signBox}</div>` : ''
      const signer = `<div style="margin-top:32px;border-top:1px solid #EEF1F6;padding-top:16px;line-height:2;font-size:13px;color:#2B3653;">
          <div>乙方：${esc(d.customer_name || '—')}</div>
          ${d && d.seal ? '<div>甲方盖章：见上方印章</div>' : ''}
          <div>签订日期：${this.pdfSignDate(d)}</div>
        </div>`
      return `
        <div style="font-family:'Microsoft YaHei','PingFang SC',sans-serif;color:#2B3653;padding:34px 40px;line-height:1.9;font-size:14px;background:#fff;">
          <div style="text-align:center;border-bottom:2px solid #3668FC;padding-bottom:14px;margin-bottom:22px;">
            <div style="font-size:20px;font-weight:700;color:#18233C;">${title}</div>
            <div style="font-size:12px;color:#8A94AD;margin-top:6px;">${sub.join(' · ')}</div>
          </div>
          ${this.renderContent(d.content || '')}
          ${sealWrap}
          ${signer}
        </div>`
    },
    escapeHtml(s) {
      if (s === undefined || s === null) return ''
      return String(s).replace(/[&<>"']/g, c => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      ))
    },
    fmtDate() {
      const d = new Date()
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
    },
    /* 签订日期：优先签署时间，否则取当天 */
    pdfSignDate(d) {
      if (!d) return this.fmtDate()
      if (d.sign_time) return this.fmtDateTime(parseInt(d.sign_time), true)
      return this.fmtDate()
    },
    copySign(url) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => this.$message.success('签署链接已复制')).catch(() => this.fallbackCopy(url))
      } else {
        this.fallbackCopy(url)
      }
    },
    fallbackCopy(url) {
      const ta = document.createElement('textarea')
      ta.value = url
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('签署链接已复制')
      } catch (e) {
        this.$message.warning('复制失败，请手动复制')
      }
      document.body.removeChild(ta)
    },
    /* 生成协议：加载订单/模板，支持选订单或手动输入 */
    /* 订单方式：把「该订单商品绑定的协议模板」回填到「选择模板」下拉
       —— 让"选模板 → 出该模板变量"这一步可见、可改；商品没绑就留空并给出提示 */
    syncProductTemplate(orderId, force) {
      if (this.genForm.manner !== 'order') return
      if (!orderId) {
        if (force) this.genForm.template_id = null
        return
      }
      if (!force && this.genForm.template_id) return
      const o = (this.orderOptions || []).find(x => String(x.id) === String(orderId))
      const pid = o && o.product_id ? o.product_id : 0
      const tid = pid ? (this.productTemplateMap[pid] || 0) : 0
      this.genForm.template_id = tid || null
    },
    openGenerate() {
      // 重置表单（手动方式当天日期默认今天）
      const todayStr = (() => { const d = new Date(); const p = n => (n < 10 ? '0' + n : '' + n); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}` })()
      this.genForm = {
        manner: 'order', order_id: null, template_id: null, title: '',
        name: '', phone: '', id_card: '', product_name: '',
        original_price: '', price: '', refund_amount: '', today: todayStr, remark: '',
        refund_channel: '', signup_time: '', template_remark: '', extraParams: {}
      }
      this.genVisible = true
      // 加载未生成协议的订单
      orderList({ page: 1, limit: 100 })
        .then(data => {
          const all = data.list || []
          this.orderOptions = all.filter(o => !o.agreement_id || parseInt(o.agreement_id) === 0)
        })
        .catch(() => { this.orderOptions = [] })
      // 加载模板列表（手动方式用）
      templateList()
        .then(data => { this.templateOptions = (data && data.list) || [] })
        .catch(() => { this.templateOptions = [] })
      // 加载商品，建立「商品 → 绑定模板」映射（订单方式未手选模板时，据此推断变量清单）
      productList()
        .then(data => {
          const map = {}
          ;((data && data.list) || []).forEach(p => {
            const tid = parseInt(p.template_id)
            if (tid > 0) map[p.id] = tid
          })
          this.productTemplateMap = map
          // 商品映射可能晚于订单选择到达，补一次回填（不覆盖用户已手选）
          this.syncProductTemplate(this.genForm.order_id, false)
        })
        .catch(() => { this.productTemplateMap = {} })
      this.$nextTick(() => {
        if (this.$refs.genForm) this.$refs.genForm.clearValidate()
      })
    },
    doGenerate() {
      this.$refs.genForm.validate(valid => {
        if (!valid) return
        this.genLoading = true
        const f = this.genForm
        let payload = {
          title: f.title, manner: f.manner, remark: f.remark || '',
          refund_channel: f.refund_channel || '', signup_time: f.signup_time || '', template_remark: f.template_remark || ''
        }
        if (f.manner === 'order') {
          payload.order_id = f.order_id
          payload.template_id = f.template_id || 0
        } else {
          payload.template_id = f.template_id
          payload.name = f.name
          payload.phone = f.phone
          payload.id_card = f.id_card
          payload.product_name = f.product_name
          payload.original_price = f.original_price
          payload.price = f.price
          payload.refund_amount = f.refund_amount
          payload.today = f.today || ''
        }
        // 模板变量：只提交当前实际渲染出来的、且非空的项，
        // 既避免留空覆盖订单/商品带出的真实值，也避免上一个模板的残留键混进来
        const shown = this.dynamicVars.length ? this.dynamicVars : this.fallbackVars
        const extra = {}
        shown.forEach(k => {
          const v = f.extraParams[k]
          const s = (v === undefined || v === null) ? '' : String(v).trim()
          if (s !== '') extra[k] = s
        })
        if (Object.keys(extra).length) payload.extra_params = extra
        agreementGenerate(payload)
          .then(() => {
            this.$message.success('协议已生成')
            this.genVisible = false
            this.loadData()
          })
          .catch(() => {})
          .finally(() => { this.genLoading = false })
      })
    },
    renderContent(html) {
      // 正文为 HTML（含 <p>），直接渲染；替换换行为 <br/> 兜底
      if (!html) return ''
      return String(html).replace(/\n/g, '<br/>')
    },
    statusTagType(s) {
      const v = parseInt(s)
      if (v === 2) return 'success'
      if (v === 1) return 'warning'
      return 'info'
    },
    fmtDateTime(ts, withSeconds) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      let s = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
      if (withSeconds) s += `:${p(d.getSeconds())}`
      return s
    }
  }
}
</script>

<style scoped>
.agreement-page { padding: 0; }

.filter-card, .table-card {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.fg-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.fg-item { display: flex; align-items: center; gap: 6px; }
.fg-item.keyword { margin-right: 2px; }
.fg-btns { display: flex; gap: 8px; }
.fg-spacer { flex: 1; }
.fg-label { font-size: 13px; color: #8A94AD; flex-shrink: 0; white-space: nowrap; }

.ag-title { font-size: 13px; font-weight: 600; color: #18233C; }
.cell-name-main { min-width: 0; }
.cell-name-text { font-size: 13px; font-weight: 600; color: #18233C; }
.cell-name-sub { font-size: 11px; color: #8A94AD; margin-top: 2px; }
.sn-text { font-size: 12px; color: #5A6580; font-family: monospace; }
.cell-time { font-size: 12px; color: #5A6580; font-variant-numeric: tabular-nums; }

.pager-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 8px 8px;
  border-top: 1px solid #F2F4F8;
  margin-top: 4px;
}

.pager-info-left { font-size: 12px; color: #8A94AD; }
.info-tag { display: inline-flex; align-items: center; padding: 3px 10px; background: #F4F6FB; border-radius: 6px; }
.info-tag .num { color: #3668FC; font-weight: 600; margin: 0 2px; }

/* 详情 */
.detail-body { min-height: 100px; }

.detail-head {
  background: linear-gradient(135deg, #3668FC 0%, #2952D8 60%, #5B8DFF 120%);
  border-radius: 12px;
  padding: 14px 20px;
  color: #fff;
}

.detail-head-row { display: flex; align-items: center; gap: 10px; padding-bottom: 10px; border-bottom: 1px dashed rgba(255,255,255,0.3); }
.detail-sn { font-size: 12px; font-family: monospace; opacity: 0.9; }

.detail-head-cust { padding-top: 10px; display: flex; align-items: center; gap: 10px; font-size: 15px; font-weight: 600; }
.detail-phone { font-size: 12px; opacity: 0.8; font-weight: 400; }

.agreement-content {
  margin-top: 14px;
  padding: 20px 24px;
  line-height: 1.9;
  font-size: 14px;
  color: #2B3653;
  background: #fff;
  min-height: 300px;
  white-space: normal;
  word-break: break-word;
}

.agreement-content :deep(p) { margin: 0 0 12px; }
.agreement-content :deep(table) { width: 100%; border-collapse: collapse; margin: 12px 0; }
.agreement-content :deep(table td) { border: 1px solid #BFBFBF; padding: 8px 10px; vertical-align: top; }

.empty-row { padding: 40px 0; text-align: center; color: #B4BDCF; font-size: 13px; }

/* 签字状态时间 */
.cell-signed-time { font-size: 12px; color: #2BB673; font-weight: 600; font-variant-numeric: tabular-nums; }
.cell-muted { color: #C2CADB; }
.qr-icon:hover { opacity: 0.8; }
.del-btn { color: #E5484D; }
.del-btn:hover { color: #ff6b70; }

/* 生成协议弹窗 */
.gen-mode { margin-bottom: 16px; }
.gen-manual-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}
.dyn-vars-head { display: flex; align-items: baseline; gap: 8px; margin: 2px 0 10px; }
.dyn-vars-title { font-size: 13px; font-weight: 600; color: #18233C; }
.dyn-vars-tip { font-size: 12px; color: #8A94AD; }
.dyn-vars-tip.is-warn { color: #E5484D; }

/* 扫码签署弹窗 */
.qr-dialog-body { text-align: center; padding: 6px 10px 4px; }
.qr-img-wrap {
  display: inline-block;
  width: 220px; height: 220px;
  padding: 10px;
  background: #fff;
  border: 1px solid #E5E9F2;
  border-radius: 10px;
}
.qr-img { width: 100%; height: 100%; display: block; }
.qr-empty { padding: 80px 0; color: #B4BDCF; font-size: 13px; }
.qr-title { margin-top: 14px; font-size: 14px; font-weight: 600; color: #18233C; }
.qr-tip { margin-top: 6px; font-size: 12px; color: #8A94AD; }
.qr-link {
  margin-top: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  background: #F4F6FB;
  border-radius: 8px;
  padding: 6px 10px;
}
.qr-link-text {
  font-size: 11px;
  color: #5A6580;
  font-family: monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 230px;
  text-decoration: none;
  cursor: pointer;
}
.qr-link-text:hover { color: #3668FC; }
.detail-sig { margin-top: 18px; padding-top: 14px; border-top: 1px solid #EEF1F6; }
.detail-sig .section-title { font-size: 13px; font-weight: 600; color: #18233C; margin-bottom: 8px; }
.sig-img {
  display: block;
  max-width: 220px;
  max-height: 96px;
  background: #fff;
  border: 1px dashed #E2E6EE;
  border-radius: 8px;
  padding: 8px;
}

/* 详情签署信息：与正文无缝衔接，甲方盖章(左)+乙方签名(右)并排，无分隔线 */
.detail-sign-block {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sign-row { display: flex; gap: 32px; flex-wrap: wrap; }
.sign-cell { flex: 1; min-width: 220px; }
.sign-line { display: flex; align-items: flex-start; gap: 12px; }
.sign-label { flex-shrink: 0; font-size: 13px; font-weight: 600; color: #18233C; }
.sign-value { font-size: 13px; color: #2B3653; flex: 1; }
.sign-box { margin-top: 8px; min-height: 96px; display: flex; align-items: center; }
.sign-empty { color: #B4BDCF; font-size: 13px; }
.seal-img {
  display: block;
  max-width: 180px;
  max-height: 96px;
  background: #fff;
  border: 1px dashed #E2E6EE;
  border-radius: 8px;
  padding: 8px;
}

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-table__row:hover > td { background: #F5F8FF !important; }
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active { background-color: #3668FC; border-color: #3668FC; }
::v-deep .el-dialog { border-radius: 12px; }
</style>